import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const SmsCtaBanner: React.FC = () => {
  return (
    <section className="wdev-cta sms-cta" aria-labelledby="sms-cta-title">
      <div className="container">
        <AnimatedSection>
          <motion.div className="wdev-cta__inner" whileHover={{ scale: 1.005 }} transition={{ duration: 0.3 }}>
            <div className="wdev-cta__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M12 3 4 9v12h16V9l-8-6Z" stroke="#2563eb" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M9 21v-6h6v6" stroke="#2563eb" strokeWidth="1.5" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="wdev-cta__text">
              <h2 id="sms-cta-title" className="wdev-cta__title">
                Ready to Digitize Your School?
              </h2>
              <p className="wdev-cta__subtitle">
                Get a demo of our school management system — server-based or mobile app.
              </p>
            </div>
            <Link to="/contact" className="wdev-cta__btn">
              Request a Demo
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default SmsCtaBanner;
